module.exports = __webpack_public_path__ + "img/content3.2ac23a98.png";